module.exports = __webpack_public_path__ + "assets/img/behaviorAnalysis.20adf57d.svg";